// extracted by mini-css-extract-plugin
export default {"label":"CustomPricePointTab_label__ul-XQ","text":"CustomPricePointTab_text__jWw38","input":"CustomPricePointTab_input__fUIaP","button":"CustomPricePointTab_button__NBW7X"};